export default __webpack_public_path__ + "static/media/Radha.d94dca69.jpg";